var _path, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatBlackIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.31664 18.4189L8.08643 18.2866L7.83367 18.368L4.63286 19.3987C4.62385 19.4016 4.61404 19.3993 4.60737 19.3926C4.60072 19.386 4.59839 19.3762 4.60124 19.3674L4.60127 19.3673L5.63203 16.1663L5.71343 15.9136L5.58107 15.6834C4.9386 14.5659 4.6 13.2986 4.6 12C4.6 7.9094 7.90995 4.6 12 4.6C16.0906 4.6 19.4 7.90995 19.4 12C19.4 16.0906 16.09 19.4 12 19.4C10.7014 19.4 9.43411 19.0614 8.31664 18.4189ZM4.03019 19.1834L4.0302 19.1834L4.03019 19.1834Z",
    stroke: "#222222",
    strokeWidth: 1.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.8,
    cy: 11.9992,
    r: 0.8,
    fill: "#222222"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11.9992,
    r: 0.8,
    fill: "#222222"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.1999,
    cy: 11.9992,
    r: 0.8,
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBlackIcon);
export default __webpack_public_path__ + "static/media/chat-black-icon.065e9869b6ca062438a442faf8decbee.svg";
export { ForwardRef as ReactComponent };